<section class="topnavbar-wrapper">
  <!-- HEADER HOME-->
  <header *ngIf="!isPropostasMenu() && !isPropostaSales() && !isLandingMenu()" class="container  is-fluid">
    <ng-container *ngTemplateOutlet="navbar"></ng-container>
  </header>
  <!-- HEADER HOME-->

  <!-- HEADER PROPOSTA -->
  <header class="container  is-fluid header-proposta" *ngIf="isPropostasMenu() && !showToggleNavbar && !isPropostaSales()">
    <div class="navbar-brand74 columns">
      <a routerLink="/" class="navbar-item is-full column">
        <img src="../../../assets/img/view/novo-logo-montreal.png" alt="montreal-viagens-logo-clube-de-hospedagem" class="navbar__header-img"/>
      </a>
      <div class="column is-vcentered">
        <i class="fas fa-bars hamburguer-icon" (click)="toggleNavbar()"></i>
      </div>
    </div>
  </header>
  <div class="float-menu" *ngIf="isOpenFloatMenu">
    <a routerLink="/como-funciona" routerLinkActive="active">Como funciona</a>
    <a routerLink="/busca-hoteis" routerLinkActive="active">Hotéis</a>
    <a href="https://www.viagensmontreal.com/blog/destinos/destinos-nacionais/" target="_blank" routerLinkActive="active">Destinos</a>
    <a routerLink="/indique-e-ganhe" routerLinkActive="active">Indique e Ganhe</a>
    <a routerLink="/contatos" routerLinkActive="active">Contatos</a>
    <a routerLink="/a-montreal" routerLinkActive="active">A Montreal</a>
  </div>

  <header *ngIf="isPropostasMenu() && showToggleNavbar" class="container  is-fluid">
    <ng-container *ngTemplateOutlet="navbar"></ng-container>
  </header>
  <!-- HEADER PROPOSTA -->

  <!-- HEADER SALES -->
  <header class="container  is-fluid header-proposta-sales" *ngIf="isPropostaSales()">
    <div class="navbar-brand74 columns">
      <a (click)="redirectHome()" class="navbar-item is-full column">
        <img src="../../../assets/img/view/novo-logo-montreal.png" alt="montreal-viagens-logo-clube-de-hospedagem" class="navbar__header-img"/>
      </a>
    </div>
  </header>
  <!-- HEADER SALES -->

  <!-- HEADER PAGE -->
  <header class="container  is-fluid header-landing" *ngIf="isLandingMenu()">
    <img src="../../../assets/img/view/novo-logo-montreal.png" alt="montreal-viagens-logo-clube-de-hospedagem"  class="navbar__header-img"/>
  </header>
  <!-- HEADER PAGE -->


  <ng-template #sidebar>
    <aside *ngIf="isOpenFloatMenu && showToggleNavbar" class="montreal-navigation" [@openClose]="isOpenFloatMenu ? 'open' : 'closed'">
      <div class="area-navigation">
        <a class="btn btn-close" id="montreal-menu-close" (click)="toggleNavbar()">
          <i class="fas fa-times"></i>
        </a>
        <a (click) ="goToClient()" id="montreal-menu-portal" target="_blank" rel="noopener" class="btn btn-login">
          <i class="fas fa-user"></i>
        </a>
        <nav>
          <img class="logo-montreal" src="../../../assets/img/logo-montreal-white-novo.png" width="340" height="101" alt="Logo Montreal"/>
          <ul class="sidebar">
            <li class="montreal-navigation-item"><a routerLink="/" (click)="toggleNavbar()">Home</a></li>
            <li class="montreal-navigation-item"><a routerLink="/como-funciona" (click)="toggleNavbar()">Como funciona</a></li>
            <li class="montreal-navigation-item">
              <a target="_blank" rel="noopener" href="https://montrealviagens.my.site.com/listagemhoteis/s/" (click)="toggleNavbar()">
                Hotéis
              </a>
            </li>
            <li class="montreal-navigation-item">
              <a target="_blank" rel="noopener" href="https://clube.viagensmontreal.com/planos-montreal/" (click)="toggleNavbar()">
                Planos
              </a>
            </li>
            <li class="montreal-navigation-item"><a routerLink="/destinos" (click)="toggleNavbar()">Destinos</a></li>
            <li class="montreal-navigation-item"><a routerLink="/indique-e-ganhe" (click)="toggleNavbar()">Indique e Ganhe</a></li>
            <li class="montreal-navigation-item"><a routerLink="/contatos" (click)="toggleNavbar()">Contatos</a></li>
            <li class="montreal-navigation-item">
              <a href="https://www.viagensmontreal.com/blog/?utm_source=Site+para+blog&utm_medium=Blog+da+Montreal&utm_id=Direcionamento+do+site+Montreal+para+o+Blog"
                 target="_blank"
                 (click)="toggleNavbar()">
                Blog
              </a>
            </li>
            <li class="montreal-navigation-item"><a routerLink="/a-montreal" (click)="toggleNavbar()">A Montreal</a></li>
            <li class="montreal-navigation-item"><a routerLink="/politica-privacidade" (click)="toggleNavbar()">Política de Privacidade</a></li>
            <li class="montreal-navigation-item">
              <a href="https://www.montrealguru.guru/regulamentos-promos/"
                 target="_blank"
                 (click)="toggleNavbar()">
                Regulamentos
              </a>
            </li>
          </ul>
        </nav>
        <nav class="montreal-navigation-nav-footer">
          <ul>
            <li class="montreal-navigation-item montreal-navigation-faca-parte current-item"><a routerLink="/faca-parte" (click)="toggleNavbar()">Faça Parte do Clube</a></li>
            <li class="montreal-navigation-item montreal-navigation-portal item-extra"><a  target="_blank" rel="noopener" (click)="goToClient()">Comunidade do Cliente <i class="fas fa-sign-in-alt"></i></a></li>
            <li class="montreal-navigation-item montreal-navigation-portal item-extra"><a  target="_blank" rel="noopener" href="https://www.viagensmontreal.com/site/novoportalhoteleiro/">Portal do Hoteleiro <i class="fas fa-sign-in-alt"></i></a></li>
            <li class="montreal-navigation-item montreal-navigation-portal item-extra"><a  target="_blank" rel="noopener" href="https://sistemas.montrealonline.com.br/sso/login?service=https%3A%2F%2Fsistemas.montrealonline.com.br%2F%3F_ga%3D2.239077313.352222308.1588614017-amp-IvY2LGLC0RkHvFd6LuRJlg">Parceiro de Negócios <i class="fas fa-sign-in-alt"></i></a></li>
            <li class="montreal-navigation-item montreal-navigation-portal item-extra"><a  target="_blank" rel="noopener" href="https://clubemontreal.empregare.com/pt-br/vagas">Trabalhe Conosco<i class="fas fa-sign-in-alt"></i></a></li>
          </ul>
        </nav>
      </div>
    </aside>
  </ng-template>

  <ng-template #navbar>
    <div id="montreal-topbar" class="navbar-end">
      <div class="buttons">
        <a class="button is-primary assine-ja" (click) = "goToCart()">
          <strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Assine já!&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>
        </a>
        <a (click)="goToClient()" target="_blank" class="button is-light">
          Comunidade do Cliente <i class="fas fa-sign-in-alt"></i>
        </a>
      </div>
    </div>
    <nav id="montreal-navigation" class="navbar align-navbar" role="navigation" aria-label="main navigation">
      <div class="navbar-brand" *ngIf="!isOpenFloatMenu">
        <a role="button" class="navbar-burger"
           (click)="toggleNavbar()"
           #navBurger
           aria-label="menu"
           aria-expanded="false">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
        <a routerLink="/" class="navbar-item no-hover navbar-logo">
          <img src="../../../assets/img/view/novo-logo-montreal.png" class="logo-header" alt="montreal-viagens-logo-clube-de-hospedagem">
        </a>
        <div class="navbar-user" *ngIf="showToggleNavbar">
          <a class="btn btn-login" (click)="goToClient()" target="_blank">
            <i class="fas fa-user"></i>
          </a>
        </div>
      </div>

      <ng-container *ngTemplateOutlet="sidebar"></ng-container>

      <div class="navbar-end">
        <div class="navbar-start">
          <a routerLink="/como-funciona" routerLinkActive="active" class="navbar-item">Como funciona</a>
          <a href="https://clube.viagensmontreal.com/planos-montreal/" target="_blank" routerLinkActive="active" class="navbar-item">Planos</a>
          <a href="https://montrealviagens.my.site.com/listagemhoteis/s/" target="_blank" routerLinkActive="active" class="navbar-item">Hotéis</a>
          <a href="https://www.viagensmontreal.com/blog/destinos/destinos-nacionais/" target="_blank" routerLinkActive="active" class="navbar-item">Destinos</a>
          <a routerLink="/indique-e-ganhe" routerLinkActive="active" class="navbar-item">Indique e Ganhe</a>
          <a routerLink="/contatos" routerLinkActive="active" class="navbar-item">Contatos</a>
          <a href="https://www.viagensmontreal.com/blog/?utm_source=Site+para+blog&utm_medium=Blog+da+Montreal&utm_id=Direcionamento+do+site+Montreal+para+o+Blog"
             target="_blank"
             routerLinkActive="active"
             class="navbar-item">
            Blog
          </a>
          <li class="menu-dropdown navbar-item navbar-item-dropdown">
            <a routerLinkActive="active" class="navbar-item">
              A Montreal <i class="fas fa-chevron-down"></i>
            </a>
            <ul class="dropdown">
              <li><a routerLink="/a-montreal">Quem somos </a></li>
              <li>
                <a target="_blank" href="https://www.montrealguru.guru/regulamentos-promos/">
                  Regulamentos
                </a>
              </li>
              <li>
                <a target="_blank" href="https://www.viagensmontreal.com/site/novoportalhoteleiro/">
                  Portal do Hoteleiro
                </a>
              </li>
              <li><a href="https://clubemontreal.empregare.com/pt-br/vagas">Trabalhe Conosco</a></li>
              <li><a routerLink="/politica-privacidade">Política de Privacidade</a></li>
              <li class="menu-dropdown-2">
                <a>Parceiro de Negócios <i class="fas fa-chevron-down"></i></a>
                <ul class="dropdown-2">
                  <li>
                    <a target="_blank"
                       href="https://sistemas.montrealonline.com.br/sso/login?service=https%3A%2F%2Fsistemas.montrealonline.com.br%2F%3F_ga%3D2.239077313.352222308.1588614017-amp-IvY2LGLC0RkHvFd6LuRJlg">
                      Já sou Parceiro
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://www.montrealguru.guru/parceiros-de-negocios/">
                      Quero ser Parceiro
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://www.montrealguru.guru/lista-parceiros/">
                      Parceiros Credenciados
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <div class="navbar-item"></div>
        </div>
      </div>
    </nav>
  </ng-template>
</section>

